<template>
  <div class="common-search">
      <div class="search-container">
        <input type="text" placeholder="" v-model="painterName" id="J_SearchPlaceholder" />
        <div class="search-btn">
          <button @click="searchKeyWord"></button>
        </div>
      </div>
  </div>
</template>
<script>
  import {getCurKeyWord} from '../utils/util';

export default {
  name: 'common-search',
  data () {
    return {
      painterName: ''
    }
  },
  methods: {
    searchKeyWord: function(){
      if($.trim(this.painterName) === ''){
        window.location.href = '/#/works/_' + new Date().getTime();
      }else{
        window.location.href = '/#/works/' + $.trim(this.painterName) + '_' + new Date().getTime();
      }
    }
  },
  mounted: function(){
    this.painterName = getCurKeyWord($.trim(this.$route.params.keyWord));
  },
  watch: {
    $route: {
      handler: function(val, oldVal){
        this.painterName = getCurKeyWord($.trim(val.params.keyWord));
      },
      // 深度观察监听
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// Search.vue?6133d4ca